export default "__VITE_PUBLIC_ASSET__f8b3355f__"